import { f as r } from "./function-uncurry-this.js";
import { t } from "./to-length.js";
import { t as o } from "./to-string.js";
import { s } from "./string-repeat.js";
import { r as e } from "./require-object-coercible.js";
var i = r(s),
  n = r("".slice),
  a = Math.ceil,
  m = function m(r) {
    return function (s, m, c) {
      var f,
        u,
        g = o(e(s)),
        l = t(m),
        p = g.length,
        h = void 0 === c ? " " : o(c);
      return l <= p || "" == h ? g : ((u = i(h, a((f = l - p) / h.length))).length > f && (u = n(u, 0, f)), r ? g + u : u + g);
    };
  },
  c = {
    start: m(!1),
    end: m(!0)
  };
export { c as s };